module.exports = __webpack_public_path__ + "img/illu4@2x.16fea2b0.png";